module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "Asset_Icon_White.26535641.png";